import type { Ref } from 'vue';

export function useConnectivity(): { isOnline: Ref<boolean> } {
  const isOnline = ref(import.meta.client ? navigator.onLine : true);

  if (import.meta.client) {
    const onOnline = () => {
      isOnline.value = true;
    };
    const onOffline = () => {
      isOnline.value = false;
    };

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    onScopeDispose(() => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    });
  }

  return { isOnline };
}
